import { object, string, number, boolean, InferType } from 'yup'
import { PaginatedResponse } from 'types/api'
export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object().shape({
  memberId: string().required(),
  page: number().optional().default(undefined),
  limit: number().optional().default(undefined),
  showPhase4Tickets: boolean().optional().default(undefined),
  sort: object()
    .shape({
      external_created_at: string().optional(),
      external_updated_at: string().optional(),
      created_at: string().optional(),
      updated_at: string().optional(),
      subject: string().optional(),
      status: string().optional(),
      note_type: string().optional(),
    })
    .optional()
    .default(undefined),
})

export type Request = InferType<typeof Schema>

export const url = ({ memberId, page, limit, showPhase4Tickets, sort }: Request) => {
  const baseUrl = `/v1/tickets/members/${memberId}`

  const params = new URLSearchParams()
  if (page !== undefined && limit !== undefined) {
    const skip = page * limit
    // Use page[skip] as expected by QueryConstructor middleware
    params.append('page[limit]', limit.toString())
    params.append('page[skip]', skip.toString())
  }

  if (showPhase4Tickets !== undefined) {
    params.append('show_phase4_tickets', showPhase4Tickets.toString())
  }

  // Add sort parameters
  if (sort) {
    Object.entries(sort).forEach(([key, value]) => {
      if (value !== undefined && typeof value === 'string') {
        params.append(`sort[${key}]`, value)
      }
    })
  }

  const queryString = params.toString()
  const finalUrl = queryString ? `${baseUrl}?${queryString}` : baseUrl

  return finalUrl
}

export type SuccessfulResponse = PaginatedResponse<any>
